import { render, staticRenderFns } from "./DataCollect.vue?vue&type=template&id=7651213e&"
import script from "./DataCollect.vue?vue&type=script&lang=js&"
export * from "./DataCollect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports